/*
  <sticky-add-to-cart>: mobile sticky bar for the product page (markup: snippets/sticky-atc.liquid).
  - Shows only after the main submit button (#ProductSubmitButton-{section}) has scrolled ABOVE the
    viewport; hides when it comes back or is below the fold.
  - Hidden while the cart drawer is open (cart-drawer gets .active in Dawn's cart-drawer.js).
  - Mirrors the main button: label, live total (.be-atc__total), disabled and loading state.
  - Guards against double submit: ignores clicks while the main button is busy.
*/
(function () {
  if (!('customElements' in window) || customElements.get('sticky-add-to-cart')) return;

  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        if (this._init) return;
        this._init = true;

        this.sectionId = this.dataset.section;
        this.mainBtn = document.getElementById('ProductSubmitButton-' + this.sectionId);
        this.btn = this.querySelector('[data-sticky-btn]');
        this.labelEl = this.querySelector('[data-sticky-label]');
        this.totalEl = this.querySelector('[data-sticky-total]');
        this.spinner = this.btn ? this.btn.querySelector('.loading__spinner') : null;
        this.priceEl = document.getElementById('price-' + this.sectionId);
        this.stickyPrice = this.querySelector('[data-sticky-price]');
        this.mainAbove = false;
        this.drawerOpen = false;

        if (!this.mainBtn || !this.btn) return;

        this.syncPrice();
        this.syncButton();
        this.observe();

        this.btn.addEventListener('click', (evt) => {
          if (this.isBusy()) {
            evt.preventDefault();
            evt.stopImmediatePropagation();
          }
        });
      }

      isBusy() {
        var m = this.mainBtn;
        return (
          m.disabled ||
          m.getAttribute('aria-disabled') === 'true' ||
          m.classList.contains('loading') ||
          this.btn.classList.contains('loading')
        );
      }

      observe() {
        var el = this;

        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              // Visible, or below the fold: the main button is still ahead of the shopper.
              el.mainAbove = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
              el.render();
            });
          }).observe(this.mainBtn);
        }

        if ('MutationObserver' in window) {
          new MutationObserver(function () {
            el.syncButton();
          }).observe(this.mainBtn, {
            attributes: true,
            attributeFilter: ['class', 'disabled', 'aria-disabled'],
            childList: true,
            subtree: true,
            characterData: true,
          });

          if (this.priceEl) {
            new MutationObserver(function () {
              el.syncPrice();
            }).observe(this.priceEl, { subtree: true, childList: true, characterData: true });
          }

          var drawer = document.querySelector('cart-drawer');
          if (drawer) {
            this.drawerOpen = drawer.classList.contains('active');
            new MutationObserver(function () {
              el.drawerOpen = drawer.classList.contains('active');
              el.render();
            }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
          }
        }
      }

      render() {
        var show = this.mainAbove && !this.drawerOpen;
        if (this.hidden === !show) return;
        this.hidden = !show;
        document.body.classList.toggle('be-sticky-atc-on', show);
      }

      syncPrice() {
        if (!this.priceEl || !this.stickyPrice) return;
        var node = this.priceEl.querySelector('.price--on-sale')
          ? this.priceEl.querySelector('.price__sale .price-item--sale')
          : this.priceEl.querySelector('.price__regular .price-item--regular');
        node = node || this.priceEl.querySelector('.price-item');
        if (node) this.stickyPrice.textContent = node.textContent.trim();
      }

      syncButton() {
        var m = this.mainBtn;
        var mainLabel = m.querySelector(':scope > span');
        if (mainLabel && this.labelEl) this.labelEl.textContent = mainLabel.textContent.trim();

        var mainTotal = m.querySelector('.be-atc__total');
        if (this.totalEl) {
          var totalText = mainTotal && !m.disabled ? mainTotal.textContent.trim() : '';
          this.totalEl.textContent = totalText ? '· ' + totalText : '';
          this.totalEl.hidden = !totalText;
        }

        this.btn.disabled = m.disabled;
        var loading = m.classList.contains('loading');
        this.btn.classList.toggle('loading', loading);
        if (loading || m.getAttribute('aria-disabled') === 'true') {
          this.btn.setAttribute('aria-disabled', 'true');
        } else {
          this.btn.removeAttribute('aria-disabled');
        }
        if (this.spinner) this.spinner.classList.toggle('hidden', !loading);
      }
    }
  );
})();
